import React from 'react'
import styled from 'styled-components'

import Icon from '~/truck/icon'
import Label from '~/truck/label'
import theme from '~/truck/theme'

const getBackgroundColor = props => (props.$withBackground ? theme.colors[props.$background] : 'trasparent')

const Message = styled.div<{ $withBackground: boolean; $background: string }>`
  background-color: ${getBackgroundColor};
  border-radius: ${theme.dimensions.borderRadius}px;
  display: flex;
  margin-left: ${theme.spacing.cozy}px;
  min-width: ${theme.spacing.cozy * 17}px;
  padding: ${theme.spacing.cozy}px;

  svg {
    margin-right: ${theme.spacing.cozy}px;
  }
`

const RatingMessage = props => {
  const { icon, label, color, background, withBackground, className } = props

  return (
    <Message className={className} $withBackground={withBackground} $background={background}>
      <Icon type={icon} color={color} />
      <Label $color={color} as="p" $textStyle="h5Semibold">
        {label}
      </Label>
    </Message>
  )
}

export default RatingMessage
